import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import CustomAgGridTable from "../../../Common-Table/CustomAgGridTable";
import {
  Spin,
  Icon,
  Button,
  Card,
  Tooltip,
  message,
  Input,
  Pagination,
  Select,
  DatePicker,
  Row,
  Col,
  Switch,
} from "antd";
import CustomHeader from "../../../CommonHeader/CustomHeader";
import moment from "moment";
import F from "../../../Functions";
import CommonHeader from "../CommonHeader";
import { useBoundStore } from "../../../store/useBoundStore";
import {
  BOBADMIN,
  EA,
  getCallMetricValue,
  REVIEWADMIN,
  REVIEWSCHEDULER,
  VONBOARDER,
} from "../../../utils/Constants";
import AdminGrid from "./AdminGrid";
import { ADMIN_DASHBORAD_RS_CHART_GRID_API, GET_APPOINTMENT_HISTORY_HISTORICAL_DATA, GET_CALL_ATTEMPS_HISTORY_DETAILS, GET_CALL_BACK_HISTORY_DETAILS, GET_NOT_INTERESTED_HISORICAL_DATA, GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY, RS_ALL_AGENCIES_API_URL } from "../../../utils/Api_enums";
import axios from "../../../api";
import { set } from "lodash";
import AdminGridColDef from "./AdminGridColDef";
import useAdminGridColDef from "./AdminGridColDef";
import getAdminGridColDefs from "./AdminGridColDef";

const dateFormat = "MM-DD-YYYY";
const DetailsPage = (props) => {
  const { Option } = Select;
  const params = new URLSearchParams(props.location.search);
  const props_label = params.get('label') || '';


  console.log("props label --", props_label)


  const {
    RSFSFilters,
    setRSFSFilters,
    resetRSFSFilters,
    RSFSCardFilters,
    setRSFSCardFilters,
  } = useBoundStore();

  const initialDateRange = RSFSCardFilters.datemodified || {
    start_date: "2010-01-01",
    end_date: "2050-01-01",
  };

  const [roles, setRoles] = useState(JSON.parse(localStorage.getItem("roles")));
  const [followUpAdminUsers, setFollowUpAdminUsers] = useState([]);
  const [agencies_list, setAgencies_list] = useState([]);
  const [users, setUsers] = useState([]);
  const [isGridVisible, setGridVisible] = useState(
    RSFSCardFilters.showLeaderBoardGrid
  );
  const [datemodified, setdatemodified] = useState(initialDateRange);
  const [userType, setUserType] = useState();
  const [selectedValue, setSelectedValue] = useState(
    RSFSCardFilters.dateRangeAdminFilter
  );

  const [selectedButton, setSelectedButton] = useState(
    RSFSFilters.selectedButton
  );
  const [currentPage, setCurrentPage] = useState(RSFSFilters.page);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [selectedAgency, setSelectedAgency] = useState(undefined);
  const [selectedAgencyValue, setSelectedAgencyValue] = useState(undefined);
  const [start_date, setStartDate] = useState(initialDateRange.start_date);
  const [period, setPeriod] = useState("all_bfiles");
  const [end_date, setEndDate] = useState(initialDateRange.end_date);
  const [searchText, setSearchText] = useState();
  const [loading, setLoading] = useState(false);


  console.log("columnDefs", columnDefs)


  // table sorting and colums
  const [sortOrders, setSortOrders] = useState({});
  const [localOrder, setLocalOrder] = useState("desc");
  const [localField, setLocalField] = useState("updated_on");

  const handleSort = (field) => {

    let newOrder;
    setSortOrders((prev) => {
      const currentOrder = prev[field] || "asc";
      newOrder = currentOrder === "asc" ? "desc" : "asc";
      return { ...prev, [field]: newOrder };
    });
    setLocalOrder(newOrder);
    setLocalField(field);
    // loadUsers()
  };


  // table data
  const [tableData, setTableData] = useState([]);



  const handleDateChange = (date, dateType) => {
    setRSFSFilters({
      selectedButton: "None",
    });

    setSelectedButton("None");

    const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;

    setdatemodified((prev) => {
      const updatedStartDate =
        dateType === "start_date" ? formattedDate : prev.start_date;
      const updatedEndDate =
        dateType === "end_date" ? formattedDate : prev.end_date;
      setRSFSFilters({
        datemodified: {
          start_date: updatedStartDate,
          end_date: updatedEndDate,
        },
      });

      if (updatedStartDate && updatedEndDate) {
        // getGridData();
        // getTableData(1)
        if (Object.keys(histryObjAPI).includes(props_label)) {
          getHistoryTableData()
        } else {
          getLiveTableData()
        }

      }

      return {
        ...prev,
        start_date: updatedStartDate,
        end_date: updatedEndDate,
      };
    });
  };

  const handleRoleChange = async (newRole) => { };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleThisMonth = () => {
    const startOfMonth = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    const endOfMonth = moment()
      .endOf("month")
      .format("YYYY-MM-DD");
    setSelectedButton("ThisMonth");
    setRSFSFilters({
      datemodified: {
        start_date: startOfMonth,
        end_date: endOfMonth,
      },
      selectedButton: "ThisMonth",
    });
    setStartDate(startOfMonth);
    setEndDate(endOfMonth);
    // getTableData(startOfMonth,endOfMonth)
    if (Object.keys(histryObjAPI).includes(props_label)) {
      getHistoryTableData(startOfMonth, endOfMonth)
    } else {
      getLiveTableData(startOfMonth, endOfMonth)
    }
  };

  const refresh = () => { };

  const handleAllBFiles = () => {
    const startOfMonth = "2010-01-01";
    const endOfMonth = "2050-01-01";
    setSelectedButton("AllBFiles");
    setStartDate(startOfMonth)
    setEndDate(endOfMonth);
    // getTableData();
    // getTableData(startOfMonth, endOfMonth, );
    if (Object.keys(histryObjAPI).includes(props_label)) {
      getHistoryTableData(startOfMonth, endOfMonth)
    } else {
      getLiveTableData(startOfMonth, endOfMonth)
    }

  };

  const get_allAgencies = async () => {
    try {
      const res = await axios.get(RS_ALL_AGENCIES_API_URL);
      setAgencies_list(res.data);
    } catch (error) {
      console.log("err", error);
    }
  };


  const getLiveTableData = async (startOfMonth, endOfMonth, pageParam) => {
    // Handle default dates
    const finalStartDate = startOfMonth || start_date;
    const finalEndDate = endOfMonth || end_date;

    // Determine page number: use passed value, or state, or fallback to 1
    const nPage = pageParam !== undefined ? pageParam : (currentPage !== undefined ? currentPage : 1);
    // Start with base URL

    let url = `${ADMIN_DASHBORAD_RS_CHART_GRID_API}grid_type=${getCallMetricValue(props_label)}`;

    // Add only parameters that are available
    if (finalStartDate) url += `&start_date=${finalStartDate}`;
    if (finalEndDate) url += `&end_date=${finalEndDate}`;
    if (nPage !== undefined) url += `&page=${nPage}`;
    if (selectedAgencyValue) {
      url += `&agency_id=${selectedAgencyValue}`
    }

    let orderBy = {
      "field": localField,
      "direction": localOrder
    }

    if (orderBy) {
      url += `&order_by=${JSON.stringify(orderBy)}`
    }

    try {
      setLoading(true)
      const res = await axios.get(url);
      const { total_records, limit } = res.data;
      const totalPages = Math.ceil(total_records / limit);
      setTableData(res.data.bfiles);
      setTotalPages(totalPages)



    } catch (error) {
      setLoading(false)
      console.log(error);
    } finally {
      setLoading(false)
    }
  };

  const handleBackToDashboard = () => {
    props.history.push('/dashboard');
  };

  const histryObjAPI = {
    // d
    "Office Appointments": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    "Phone Appointments": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    "Virtual Appointments": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    "Reschedule Appointments": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    "Appointment Scheduled": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    "Opportunity": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    "Lead": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,

    // d
    "Call Attempts": GET_CALL_ATTEMPS_HISTORY_DETAILS,
    "Call Back Requested": GET_CALL_BACK_HISTORY_DETAILS,
    //d 
    "Life Insurance": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "P&C": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Commercial/Farm": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Retirement": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Thank You / Referrals": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Cross-Sell": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Commercial": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Re-Quote": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Win Back": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,
    "Event Call": GET_SUB_TYPE_OF_CALL_APPOINTMENT_HISTORY,


    //d
    // "PNC Review": "pnc_review",
    "Not Interested": GET_NOT_INTERESTED_HISORICAL_DATA,
    "Call Attempts": GET_CALL_ATTEMPS_HISTORY_DETAILS,
    "Total Scheduled Appointments": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA,
    "Requested to be Rescheduled": GET_APPOINTMENT_HISTORY_HISTORICAL_DATA

  }

  const getHistoryTableData = async (startOfMonth, endOfMonth, pageParam) => {

    const myObj = {
      "Office Appointments": { location: 'Office' },
      "Phone Appointments": { location: 'Phone' },
      "Virtual Appointments": { location: 'Virtual' },
      "Reschedule Appointments": { reschedule: true },
      "Opportunity": { type_of_call: 'FollowUp' },
      "Lead": { type_of_call: 'Prospect' },
      "Appointment Scheduled": null,

      "Call Attempts": null,

      "Life Insurance": { sub_type_of_call: "Life Insurance" },
      "P&C": { sub_type_of_call: "P&C Review" },
      "Commercial/Farm": { sub_type_of_call: "Commercial" },
      "Retirement": { sub_type_of_call: "Retirement" },
      "Thank You / Referrals": { sub_type_of_call: "Thank You / Referrals" },
      "Cross-Sell": { sub_type_of_call: "Cross-Sell" },
      "Commercial": { sub_type_of_call: "Commercial" },
      "Re-Quote": { sub_type_of_call: "Re-Quote" },
      "Win Back": { sub_type_of_call: "Win Back" },
      "Event Call": { sub_type_of_call: "Event Call" },
      "Not Interested": null,
      "Total Scheduled Appointments": null,
      "Requested to be Rescheduled": { reschedule: true }

    }

    let toggle_user_type = RSFSCardFilters.defaultToggleUserRole == REVIEWADMIN ? REVIEWADMIN : BOBADMIN;

    const finalStartDate = startOfMonth || start_date;
    const finalEndDate = endOfMonth || end_date;

    // Determine page number: use passed value, or state, or fallback to 1
    const nPage = pageParam !== undefined ? pageParam : (currentPage !== undefined ? currentPage : 1);

    let url = `${histryObjAPI[props_label]}`
    const queryParams = new URLSearchParams();

    // if(Object.keys(myObj).includes(props_label)){
    // if (props_label in myObj && myObj[props_label] !== null) {
    //   // url+=`?${JSON.stringify(myObj[props_label])}`
    //    const params = new URLSearchParams(myObj[props_label]).toString();
    //     url += `?${params}`;
    // }

    // Add custom object-based query params if present
    if (props_label in myObj && myObj[props_label] !== null) {
      const objParams = new URLSearchParams(myObj[props_label]);
      for (const [key, value] of objParams.entries()) {
        queryParams.set(key, value);
      }
    }


    // Add dynamic parameters
    if (finalStartDate) queryParams.set("start_date", finalStartDate);
    if (finalEndDate) queryParams.set("end_date", finalEndDate);
    if (nPage !== undefined) queryParams.set("page", nPage);
    if (selectedAgencyValue) queryParams.set("agency_id", selectedAgencyValue);
    queryParams.set("toggle_user_type", toggle_user_type);

    // Sort options
    if (localOrder && localField) {
      queryParams.set("sort_order", localOrder);
      queryParams.set("sort_by", localField);
    }

    // Combine base and query string
    const finalURl = `${url}?${queryParams.toString()}`;

    //  // Add only parameters that are available
    //   if (finalStartDate) url += `&start_date=${finalStartDate}`;
    //   if (finalEndDate) url += `&end_date=${finalEndDate}`;
    //   if (nPage !== undefined) url += `&page=${nPage}`;
    //   if(selectedAgencyValue){
    //     url += `&agency_id=${selectedAgencyValue}`
    //   }

    // if(true){
    //   // url+=`&toggle_user_type=${}`
    //   url+=`&toggle_user_type=REVIEWADMIN`
    // }


    // let orderBy = {
    //   "field": localField,
    //   "direction": localOrder
    // }

    // if(orderBy){
    // url += `&sort_order=${JSON.stringify(localOrder)}&sort_by=${localField}`
    // }

    try {
      setLoading(true)
      const res = await axios.get(finalURl);
      // const { total_records, limit } = res.data;
      // const totalPages = Math.ceil(total_records / limit);  
      setTableData(res.data.data);
      setTotalPages(res.data.total)



    } catch (error) {
      setLoading(false)
      console.log(error);
    } finally {
      setLoading(false)
    }


  }




  const selectAgency = (value, name) => {
    setSelectedAgency(value);
    setSelectedAgencyValue(value);
  };

  // useEffect(() => {
  //   if(selectedAgencyValue){
  //     getTableData()
  //   }
  // }, [selectedAgencyValue]);



  useEffect(() => {
    // live grid api call for RS
    if (Object.keys(histryObjAPI).includes(props_label)) {
      getHistoryTableData()
    } else {
      getLiveTableData()
    }
    get_allAgencies();
  }, [localField, localOrder, selectedAgencyValue, props_label, sortOrders]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // getTableData(undefined,undefined,page);
    if (Object.keys(histryObjAPI).includes(props_label)) {
      getHistoryTableData(undefined, undefined, page)
    } else {
      getLiveTableData(undefined, undefined, page)
    }
  };







  const CustomTooltip = (props) => {
    return (
      <div
        style={{
          background: "rgba(0, 0, 0, 0.8)",
          color: "white",
          padding: "8px 12px",
          borderRadius: "4px",
          fontSize: "12px",
          maxWidth: "200px",
          textAlign: "center",
        }}
      >
        {props.value}
      </div>
    );
  };

  const getMonthFromDate = (dateString) => {
    if (!dateString) return "No Review";
    return moment(dateString).format("MMMM");
  };







  //  based on user toggle and chart label we update our columndef 
  useEffect(() => {

  }, [])
  // bckup
  //  const coleDef = [
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Name",
  //     valueGetter: (params) => `${params.data.name || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["name"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Name"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "name",
  //       sortOrder: sortOrders["name"],
  //       handleSort,
  //     }),
  //     colId: "name",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //   },
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Phone",
  //     valueGetter: (params) => `${params.data.phone || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["phone"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Phone"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "phone",
  //       sortOrder: sortOrders["phone"],
  //       handleSort,
  //     }),
  //     colId: "phone",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //   },
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Agency",
  //     valueGetter: (params) => `${params.data.agency_name || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["Agency"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Agency"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "agency_name",
  //       sortOrder: sortOrders["agency_name"],
  //       handleSort,
  //     }),
  //     colId: "agency_name",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //   },
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Type of Call",
  //     valueGetter: (params) => `${params.data.type_of_call || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["Type of Call"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Type of Call"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "type_of_call",
  //       sortOrder: sortOrders["type_of_call"],
  //       handleSort,
  //     }),
  //     colId: "type_of_call",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //   },
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Sub Type",
  //     valueGetter: (params) => `${params.data.sub_type_of_call || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["Sub Type"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Sub Type"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "sub_type_of_call",
  //       sortOrder: sortOrders["sub_type_of_call"],
  //       handleSort,
  //     }),
  //     colId: "sub_type_of_call",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //   },
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Review Active Month",
  //     // valueGetter: (params) => `${params.data.rs_effective_date || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["Review Active Month"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Review Active Month"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "rs_effective_date",
  //       sortOrder: sortOrders["rs_effective_date"],
  //       handleSort,
  //     }),
  //     colId: "rs_effective_date",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //      valueGetter: (params) => {
  //         if (!params.data) return '';
  //         return getMonthFromDate(params.data.rs_effective_date);
  //     },
  //   },
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Schedule By Date",
  //     // valueGetter: (params) => `${params.data.expiration_date || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["Schedule By Date"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Schedule By Date"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "expiration_date",
  //       sortOrder: sortOrders["expiration_date"],
  //       handleSort,
  //     }),
  //     colId: "expiration_date",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //       valueGetter: (params) => {
  //           if (!params.data) return '';
  //           return params.data.expiration_date ? moment(params.data.expiration_date).format('MM/DD/YYYY') : '-';
  //     },
  //   },
  //   {
  //     headerClass: "custom-ag-header",
  //     headerName: "Who Created",
  //     valueGetter: (params) => `${params.data.who_created || ""}`,
  //     sortable: true,
  //     // filter: true,
  //     sortOrder: sortOrders["Who Created"],
  //     // handleSort,
  //     headerComponentParams: (params) => ({
  //       headers: ["Who Created"],
  //       colDef: params.column.getColDef(),
  //       columnApi: params.columnApi,
  //       field: "who_created",
  //       sortOrder: sortOrders["who_created"],
  //       handleSort,
  //     }),
  //     colId: "who_created",
  //     headerComponent: CustomHeader,
  //     tooltipComponent: CustomTooltip,
  //   },
  // ];


  const columnDefs = getAdminGridColDefs({
    props_label,
    handleSort,
    sortOrders,
    CustomHeader,
    CustomTooltip,
    getMonthFromDate,
    getMonthFromDate,

  });
  const [currentColDefs, setCurrentColeDefs] = useState(columnDefs)



  return (
    <div>
      <div
        style={{ marginBottom: '10px' }}
        className='hyperlink-shomore-stat'
        onClick={handleBackToDashboard}
        onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
        onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
      >
        <Icon type="arrow-left" />
        Back to Dashboard
      </div>
      {/* filters  */}
      <div>
        <CommonHeader
          user={props.auth.user}
          onRoleChange={handleRoleChange}
          isHidden={false}
        />
        <div
          className="inlineButton"
          style={{ marginTop: "25px", gap: "10px" }}
        >
          <div
            style={{ display: "flex", justifyContent: "start", gap: "10px" }}
          >
            <div style={{ display: "flex", gap: "10px", position: "relative" }}>
              <Button
                className={
                  selectedButton === "AllBFiles" || !selectedButton
                    ? "bgPrimary"
                    : "bgGray"
                }
                onClick={handleAllBFiles}
              >
                All B Files
              </Button>

              <Button
                className={
                  selectedButton === "ThisMonth" ? "bgPrimary" : "bgGray"
                }
                value={period}
                onClick={() => handleThisMonth()}
              >
                This Month
              </Button>
            </div>

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                position: "relative",
                width: "200px",
              }}
            >
              <Input
                className="dropDown search-name-input"
                placeholder="Search File"
                value={searchText}
                onChange={handleSearch}
              />
              {searchText ? (
                <Icon
                  type="close"
                  onClick={() => handleSearch({ target: { value: "" } })}
                  style={{ right: "30px" }}
                  className="icon-style"
                />
              ) : (
                <Icon
                  type="search"
                  style={{ right: "30px" }}
                  className="icon-style"
                />
              )}
            </div>
            <div style={{ position: "relative" }}>
              <Select
                allowClear
                showSearch
                className="dropDown custom-select"
                placeholder="Search By Agency"
                optionFilterProp="children"
                onChange={(value, option) => {
                  let agencyId = value;
                  let agencyName = "";
                  if (option && option.props && option.props.children) {
                    agencyName = option.props.children;
                  }
                  selectAgency(agencyId, agencyName);
                }}
                filterOption={(input, option) =>
                  option.props.children &&
                  option.props.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={selectedAgency}
              >
                {agencies_list.map((opt) => (
                  <Option
                    key={opt.id}
                    value={opt.id}
                    style={{ fontSize: "12px" }}
                  >
                    {opt.name}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div
            className="datepicker-rsfs"
            style={{ marginTop: "-20px", marginRight: "-50px" }}
          >
            <Row style={{ display: "flex", gap: "10px" }}>
              <Col span={8}>
                <div className="datepicker-label-rsfs">Start Date</div>
                <DatePicker
                  className="custom-datepicker"
                  value={
                    datemodified.start_date
                      ? moment(datemodified.start_date)
                      : null
                  }
                  format={dateFormat}
                  onChange={(e) => {
                    const newDate = e ? e : moment();
                    handleDateChange(newDate, "start_date");
                  }}
                />
              </Col>
              <Col span={8}>
                <div className="datepicker-label-rsfs">End Date</div>
                <DatePicker
                  value={
                    datemodified.end_date ? moment(datemodified.end_date) : null
                  }
                  format={dateFormat}
                  onChange={(e) => {
                    const newDate = e ? e : moment();
                    handleDateChange(newDate, "end_date");
                  }}
                />
              </Col>

              <Col span={8}>
                <Button
                  type="primary"
                  className="refresh-con"
                  onClick={() => refresh()}
                >
                  <Icon type="reload" />
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {/* Ag grid table  */}
      <AdminGrid tableData={tableData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        loading={loading}
        coleDef={columnDefs}
        props_label={props_label}
      />
    </div>
  );
};

export default withRouter(DetailsPage);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/shared-charts/DetailsPage.jsx